<template>
  <div v-if="isActive" class="citypay">
    <div v-if="data.widgetTag" class="ca-promotional-widget"
         :data-widget-type="data.widgetType"
         :data-widget-item-sku="data.widgetSku"
         :data-widget-item-price="data.widgetPrice"
         :data-widget-financing-page-url="data.widgetPageUrl"
         :data-widget-item-tag="data.widgetTag"
    >
    </div>
    <div v-else class="ca-promotional-widget"
         :data-widget-type="data.widgetType"
         :data-widget-item-sku="data.widgetSku"
         :data-widget-item-price="data.widgetPrice"
         :data-widget-financing-page-url="data.widgetPageUrl"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CityPay',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, String, Array],
      default: null
    }
  },
  mounted () {
    if (this.isActive && this.data) {
      this.loadChargeAfterScript()
    }
  },
  beforeDestroy () {
    const oldScript = document.getElementById('chargeafter-script')
    if (oldScript) oldScript.remove()
    delete window.ChargeAfter
  },
  watch: {
    isActive (newVal) {
      if (newVal && this.data) {
        this.loadChargeAfterScript()
      }
    }
  },
  methods: {
    loadChargeAfterScript () {
      const oldScript = document.getElementById('chargeafter-script')
      if (oldScript) oldScript.remove()
      delete window.ChargeAfter

      const script = document.createElement('script')
      script.id = 'chargeafter-script'
      script.src = `https://${this.data.citypayScriptHost}/web/v2/chargeafter.min.js?t=${Date.now()}`
      script.type = 'text/javascript'
      script.async = true
      script.onload = () => this.initChargeAfter()
      document.body.appendChild(script)
    },
    initChargeAfter () {
      if (window.ChargeAfter) {
        window.ChargeAfter.init({
          apiKey: this.data.apiKey,
          storeId: this.data.storeId || ''
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.citypay {
  padding: 10px 0px 30px 0px;
}
</style>